import { motion } from "framer-motion";
import { Calendar, Clock, MapPin, ArrowDown } from "lucide-react";
import { HERO } from "@/data";

const fade = (delay) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay },
});

export const Hero = () => (
  <section id="top" className="relative overflow-hidden pt-36 pb-20 md:pt-44">
    <div className="pointer-events-none absolute -top-32 -right-32 h-[460px] w-[460px] rounded-full bg-[var(--lime)]/15 blur-3xl" />
    <div className="pointer-events-none absolute top-40 -left-40 h-[420px] w-[420px] rounded-full bg-[var(--forest)]/10 blur-3xl" />

    <div className="relative mx-auto max-w-6xl px-6">
      <motion.h1
        {...fade(0.05)}
        data-testid="hero-title"
        className="max-w-4xl text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight text-[var(--ink)]"
      >
        {HERO.titleLead}{" "}
        <span className="text-[var(--forest)]">{HERO.titleAccent}</span>
      </motion.h1>

      <motion.p
        {...fade(0.18)}
        className="mt-6 text-xl sm:text-2xl font-semibold text-[var(--forest)]"
      >
        {HERO.subtitle}
      </motion.p>

      <motion.div
        {...fade(0.3)}
        className="mt-8 flex flex-wrap items-center gap-x-7 gap-y-3 text-[var(--ink)]/75"
      >
        <span className="flex items-center gap-2 text-sm font-medium">
          <Calendar className="h-4 w-4 text-[var(--forest)]" /> {HERO.date}
        </span>
        <span className="hidden sm:block h-4 w-px bg-black/15" />
        <span className="flex items-center gap-2 text-sm font-medium">
          <Clock className="h-4 w-4 text-[var(--forest)]" /> {HERO.time}
        </span>
        <span className="hidden sm:block h-4 w-px bg-black/15" />
        <span className="flex items-center gap-2 text-sm font-medium">
          <MapPin className="h-4 w-4 text-[var(--forest)]" /> {HERO.location}
        </span>
      </motion.div>

      <motion.div {...fade(0.42)} className="mt-10">
        <a
          href="#pozvanka"
          data-testid="hero-scroll-cta"
          className="group inline-flex items-center gap-2 rounded-full bg-[var(--forest)] px-7 py-3.5 text-sm font-semibold text-white hover:bg-[var(--forest-dark)] transition-colors duration-200"
        >
          Zjistit více
          <ArrowDown className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-1" />
        </a>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.98, y: 30 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.5 }}
        className="mt-16 overflow-hidden rounded-3xl shadow-xl ring-1 ring-black/5"
      >
        <img
          src={HERO.image}
          alt={HERO.imageAlt}
          data-testid="hero-image"
          className="h-[320px] w-full object-cover md:h-[520px]"
        />
      </motion.div>
    </div>
  </section>
);
